import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { type ChangeLanguageOptions, useChangeLanguage } from '@unifyapps/i18n/client';
import type { CurrentUserDetails } from '@unifyapps/network/generated/models/currentUserDetails';
import { getLocaleToUse } from './localeToUse/getLocaleToUse';

export function useSetLocale() {
  const changeLanguage = useChangeLanguage();
  return useEventCallback(
    (user: CurrentUserDetails, locale?: string, options?: ChangeLanguageOptions) => {
      const localeToUse = getLocaleToUse(user, locale);
      if (!localeToUse) return;
      changeLanguage(localeToUse, options);
    },
  );
}
